// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__FncB0","title":"BackImages_title__3wnxs","images":"BackImages_images__dfgQC"};